import React, {type FC} from 'react';
import {IProduct} from '../../../../types/galleryTypes';
import {useGlobals, withGlobals} from '../../../../globalPropsContext';
import {ProductQuickAddMobile} from './ProductQuickAddMobile/ProductQuickAddMobile';
import {ProductQuickAddDesktop} from './ProductQuickAddDesktop/ProductQuickAddDesktop';

export interface IProductQuickAddProps {
  product: IProduct;
  productItemRef: React.RefObject<HTMLDivElement>;
  quantity: number;
}

const ProductQuickAddComp: FC<IProductQuickAddProps> = ({product, productItemRef, quantity}) => {
  const {shouldShowMobile} = useGlobals();

  return shouldShowMobile ? (
    <ProductQuickAddMobile product={product} quantity={quantity} />
  ) : (
    <ProductQuickAddDesktop product={product} productItemRef={productItemRef} quantity={quantity} />
  );
};

export const ProductQuickAdd = withGlobals(ProductQuickAddComp);
